import React, { useEffect, useRef } from 'react';
import './infload.css';
import Lottie from 'lottie-web';
import animationData from './animationdata.json'

const InfLoader = ({size}) => {
    const container = useRef(null);
    let classname; 

    useEffect(() => {
      Lottie.loadAnimation({
        container: container.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData // Your animation JSON data
      });
    }, []);

    switch(size){
      case 'sm':
        classname = 'lottie-container-sm'
      break;
      default: 
      classname = 'lottie-container'
    }
  
    return (
      <div className={classname} ref={container}></div>
    );
};

export default InfLoader;
